import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-receivable-summary',
  templateUrl: './receivable-summary.component.html',
  styleUrls: ['./receivable-summary.component.css']
})
export class ReceivableSummaryComponent implements OnInit {

  date = new DatePipe('en-US').transform(new Date(), 'MM-dd-yyyy')
  date_now = new DatePipe('en-US').transform(new Date(), 'MM-dd-yyyy')
  year_select: any;
  data_years = [] as any;
  data_all = {
    loan: [],
    cont: [],
    sup: [],
    adv: []
  }
  data_loan: any; //เงินให้กู้ยืม
  data_cont: any; //เงินอุดหนุน
  data_sup: any; //เงินสนับสนุน
  data_adv: any //เงินทดรองจ่าย
  sum = {
    loan: {
      all: 0,
      short: 0,
      long: 0,
      sum: 0
    },
    cont: {
      all: 0,
      short: 0,
      long: 0,
      sum: 0
    },
    sup: {
      all: 0,
      short: 0,
      long: 0,
      sum: 0
    },
    adv: {
      all: 0,
      short: 0,
      long: 0,
      sum: 0
    },
    all: {
      all: 0,
      short: 0,
      long: 0,
      sum: 0
    }
  }

  page = 1;
  count = 0;
  tableSize = 20;

  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    document.getElementById('receivables')!.classList.toggle("active");
    document.getElementById('receivable')!.classList.toggle("show");
    document.getElementById('summary')!.classList.toggle("active");

    this.date_now = this.dateThaiFormat(this.date_now)
    this.getAllData()
  }

  ngOnDestroy() {
    document.getElementById('receivables')!.classList.remove("active");
    document.getElementById('receivable')!.classList.remove("show");
    document.getElementById('summary')!.classList.remove("active");
  }

  async getAllData() {
    this.sum = {
      loan: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      cont: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      sup: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      adv: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      all: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      }
    }
    let all_debt = [] as any
    await this.services.get("funding").then((res: any) => {
      all_debt = res.filter((data: any) => {
        return data.status.toLowerCase().match('enable')
      })
    });
    
    await this.services.get('m_receivabledetail').then((resp: any) => {
      const all = resp.filter((res: any) => {
        if (res.fiscal_year != null) {
          this.data_years.push(res.fiscal_year);
        }
        res.debt_id = Number(res.debt_id)
      if(res.status.toLowerCase().match('enable')){
        if (res.project_key) {
          let debt = all_debt.find((f:any)=>{
            return f.project_key.toLowerCase() == (res.project_key).toLowerCase()
          })
          if(debt){
            res.province = debt.province
          }else{
            res.province = ''
          }
        }else{
          res.province = ''
        }
      }
        return res.status.toLowerCase().match('enable')
      })
      this.data_all.loan = all.filter((data: any) => {
        if (data.type_money != null) {
          return data.type_money.match("เงินให้กู้ยืม")
        }
      })
      this.data_all.cont = all.filter((data: any) => {
        if (data.type_money != null) {
          return data.type_money.match("เงินอุดหนุน")
        }
      })
      this.data_all.sup = all.filter((data: any) => {
        if (data.type_money != null) {
          return data.type_money.match("เงินสนับสนุน")
        }
      })
      this.data_all.adv = all.filter((data: any) => {
        if (data.type_money != null) {
          return data.type_money.match("เงินทดรองจ่าย")
        }
      })      
    })
    this.data_all.loan = this.data_all.loan.sort((a: any, b: any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))
    this.data_all.cont = this.data_all.cont.sort((a: any, b: any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))
    this.data_all.sup = this.data_all.sup.sort((a: any, b: any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))
    this.data_all.adv = this.data_all.adv.sort((a: any, b: any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))

    this.data_years = [...new Set(this.data_years)].sort();
    this.data_loan = this.data_all.loan
    this.data_cont = this.data_all.cont
    this.data_sup = this.data_all.sup
    this.data_adv = this.data_all.adv

    //add index
    await this.data_loan.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)
      this.sum.loan.all += Number(data.amount_receive);
      this.sum.loan.short += Number(data.short_term);
      this.sum.loan.long += Number(data.long_term);
      this.sum.loan.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
    await this.data_cont?.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)
      this.sum.cont.all += Number(data.amount_receive);
      this.sum.cont.short += Number(data.short_term);
      this.sum.cont.long += Number(data.long_term);
      this.sum.cont.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
    await this.data_sup?.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)
      this.sum.sup.all += Number(data.amount_receive);
      this.sum.sup.short += Number(data.short_term);
      this.sum.sup.long += Number(data.long_term);
      this.sum.sup.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
    await this.data_adv?.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)
      this.sum.adv.all += Number(data.amount_receive);
      this.sum.adv.short += Number(data.short_term);
      this.sum.adv.long += Number(data.long_term);
      this.sum.adv.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
  }

  async select_year(year: any) {
    this.sum = {
      loan: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      cont: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      sup: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      adv: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      },
      all: {
        all: 0,
        short: 0,
        long: 0,
        sum: 0
      }
    }
    this.data_loan = this.data_all.loan.filter((data: any) => {
      if (data.type_money != null) {
        return data.fiscal_year.match(year)
      }
    })
    this.data_cont = this.data_all.cont.filter((data: any) => {
      if (data.type_money != null) {
        return data.fiscal_year.match(year)
      }
    })
    this.data_sup = this.data_all.sup.filter((data: any) => {
      if (data.type_money != null) {
        return data.fiscal_year.match(year)
      }
    })
    this.data_adv = this.data_all.adv.filter((data: any) => {
      if (data.type_money != null) {
        return data.fiscal_year.match(year)
      }
    })
    //add index
    await this.data_loan.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)
      this.sum.loan.all += Number(data.amount_receive);
      this.sum.loan.short += Number(data.short_term);
      this.sum.loan.long += Number(data.long_term);
      this.sum.loan.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
    await this.data_cont?.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)
      this.sum.cont.all += Number(data.amount_receive);
      this.sum.cont.short += Number(data.short_term);
      this.sum.cont.long += Number(data.long_term);
      this.sum.cont.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
    await this.data_sup?.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)

      this.sum.sup.all += Number(data.amount_receive);
      this.sum.sup.short += Number(data.short_term);
      this.sum.sup.long += Number(data.long_term);
      this.sum.sup.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
    await this.data_adv?.forEach((data: any, i: any) => {
      data.i = i + 1
      data.sum = parseFloat(data.short_term) + parseFloat(data.long_term)

      this.sum.adv.all += Number(data.amount_receive);
      this.sum.adv.short += Number(data.short_term);
      this.sum.adv.long += Number(data.long_term);
      this.sum.adv.sum += Number(data.sum);

      this.sum.all.all += Number(data.amount_receive);
      this.sum.all.short += Number(data.short_term);
      this.sum.all.long += Number(data.long_term);
      this.sum.all.sum += Number(data.sum);
    });
  }

  dateThaiFormat(date: any) {
    return date = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    // document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }
}
